import './header.scss';

import { t } from 'i18next';
import { FC } from 'react';

import logo from './descomplica-faculdade-digital.svg';

const Header: FC<any> = () => {
  return (
    <nav className="header" tabIndex={1}>
      <img
        className="header__logo"
        src={logo}
        alt={t('header.logoAlt') || ''}
      />
    </nav>
  );
};

export default Header;
